import { createAction } from '@reduxjs/toolkit';

export const initApp = createAction('[Init] initApp');
export const online = createAction('[Init] online');
export const offline = createAction('[Init] offline');
